import { useCallback } from "react";
import type { BadgeZoneViolationIncident } from "../../../api";
import { store } from "../../../store";
import { useFetchAction, type UseFetchActionReturn } from "../utils";

export const useFetchBadgeZoneViolationIncident = (
    id?: string | null,
): UseFetchActionReturn<BadgeZoneViolationIncident | undefined> => {
    const fetchBadgeZoneViolationIncident: () => Promise<BadgeZoneViolationIncident | undefined> =
        useCallback(() => {
            if (id) {
                return store.badgeZoneViolationEventsApi.badgeZoneViolationEventsReadBadgeZoneViolationIncident(
                    { id },
                );
            } else {
                return Promise.resolve(undefined);
            }
        }, [id]);
    return useFetchAction(fetchBadgeZoneViolationIncident);
};
